export default "__VITE_ASSET__D1rVkdCl__"